module.exports = "/fonts/opensansbold.woff2";